import { render, staticRenderFns } from "./spv.vue?vue&type=template&id=5b6fb149&"
import script from "./spv.vue?vue&type=script&lang=js&"
export * from "./spv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports